export enum PayoutTransactionStatusEnum {
    Pending = 0,
    Processing = 1,
    Completed = 2
}
